function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { getGridImageWithParagraphProps } from "../live-board-tabs-service";
export const TOP_VIDEO_PROPS = {
    video: {
        src: {
            singleUrl: "https://dapulse-res.cloudinary.com/video/upload/Generator_featured%20images/live-board-2022/automations/automation.mp4"
        },
        autoPlay: true,
        playWhenVisible: false,
        loop: true
    }
};
const firstRow = [
    _object_spread_props(_object_spread({}, getGridImageWithParagraphProps({
        imageSrc: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/live-board-2022/automations/1_card_automation.png",
        fullParagraphTitle: "automations - row: 1 col: 1"
    })), {
        cardNumOfColumnsWidth: 1.33
    }),
    _object_spread_props(_object_spread({}, getGridImageWithParagraphProps({
        imageSrc: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/live-board-2022/automations/2_card_automation.png",
        fullParagraphTitle: "automations - row: 1 col: 2"
    })), {
        cardNumOfColumnsWidth: 1.33
    }),
    _object_spread_props(_object_spread({}, getGridImageWithParagraphProps({
        imageSrc: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/live-board-2022/automations/3_card_automation.png",
        fullParagraphTitle: "automations - row: 1 col: 3"
    })), {
        cardNumOfColumnsWidth: 1.33
    })
];
const secondRow = [
    _object_spread_props(_object_spread({}, getGridImageWithParagraphProps({
        imageSrc: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/live-board-2022/automations/4_card_automation.png",
        fullParagraphTitle: "automations - row: 2 col: 1"
    })), {
        cardNumOfColumnsWidth: 1.33
    }),
    _object_spread_props(_object_spread({}, getGridImageWithParagraphProps({
        imageSrc: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/live-board-2022/automations/5_card_automation.png",
        fullParagraphTitle: "automations - row: 2 col: 2"
    })), {
        cardNumOfColumnsWidth: 1.33
    }),
    _object_spread_props(_object_spread({}, getGridImageWithParagraphProps({
        imageSrc: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/live-board-2022/automations/6_card_automation.png",
        fullParagraphTitle: "automations - row: 2 col: 3"
    })), {
        cardNumOfColumnsWidth: 1.33
    })
];
export const automationsGridItems = [
    firstRow,
    secondRow
];
